export * from './gutachten-filter.component';
export * from './gutachten-filter.component.module';